module.exports = require("jquery-ui-dist/jquery-ui");